import { render, staticRenderFns } from "./redirectUrlEdit.vue?vue&type=template&id=40580c86&"
import script from "./redirectUrlEdit.vue?vue&type=script&lang=js&"
export * from "./redirectUrlEdit.vue?vue&type=script&lang=js&"
import style0 from "./redirectUrlEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports